import { render, staticRenderFns } from "./awemeList.vue?vue&type=template&id=3312b4e4&scoped=true"
import script from "./awemeList.vue?vue&type=script&lang=js"
export * from "./awemeList.vue?vue&type=script&lang=js"
import style0 from "./awemeList.vue?vue&type=style&index=0&id=3312b4e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3312b4e4",
  null
  
)

export default component.exports